(function() {
  "use strict";

  angular.module("sempraWebapp").config(translationsConfig);

  /** @ngInject */
  function translationsConfig(
    $translateProvider,
    srTranslations,
    enTranslations,
    deTranslations,
    frTranslations,
    hrTranslations,
    plTranslations,
    slTranslations,
    csTranslations,
    ukTranslations,
    huTranslations,
    roTranslations,
    ruTranslations,
    nlTranslations,
    svTranslations,
    fiTranslations,
    twTranslations,
    skTranslations
  ) {
    $translateProvider
      .translations("en", enTranslations)
      .translations("sr", srTranslations)
      .translations("de", deTranslations)
      .translations("pl", plTranslations)
      .translations("sl", slTranslations)
      .translations("cs", csTranslations)
      .translations("hr", hrTranslations)
      .translations("fr", frTranslations)
      .translations("uk", ukTranslations)
      .translations("hu", huTranslations)
      .translations("ro", roTranslations)
      .translations("ru", ruTranslations)
      .translations("nl", nlTranslations)
      .translations("sv", svTranslations)
      .translations("fi", fiTranslations)
      .translations("tw", twTranslations)
      .translations("sk", skTranslations);

    $translateProvider.preferredLanguage("sr");
    $translateProvider.useSanitizeValueStrategy("sanitizeParameters");
  }
})();
